<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>
                <b-button
                        @click="storePrices"
                        variant="success"
                        class="btn-round">{{$t('saveTitle')}}
                </b-button>
            </template>
        </navbar>



        <b-card>

            <b-row>
                <b-col cols="12" md="3">
                    <b-form-checkbox v-model="showLifferservice">Ihr Lieferservice in Wien</b-form-checkbox>
                </b-col>
                <b-col cols="12" md="3">
                    <b-form-checkbox v-model="showDpdExpress">Österreich / Deutschland</b-form-checkbox>
                </b-col>
                <b-col cols="12" md="3">
                    <b-form-checkbox v-model="showDpdEU">Andere EU-Länder</b-form-checkbox>
                </b-col>
                <b-col cols="12" md="3">
                    <b-form-checkbox v-model="showDpdInPerson">Selbstabholung bei Lord of Hanf</b-form-checkbox>
                </b-col>
                <b-col cols="12" md="3" class="mt-4">
                    <b-form-checkbox v-model="showPaymentPurhcaseInvoice">Kauf auf Rechnung</b-form-checkbox>
                </b-col>
                <b-col cols="12" md="3" class="mt-4">
                    <b-form-checkbox v-model="showPaymentVisa">Payment Visa/Card</b-form-checkbox>
                </b-col>
                <b-col cols="12" md="3" class="mt-4">
                    <b-form-checkbox v-model="showPaymentEps">Payment EPS</b-form-checkbox>
                </b-col>
                <b-col cols="12" md="3" class="mt-4">
                    <b-form-checkbox v-model="showPaymentGiropay">Payment GIROPAY</b-form-checkbox>
                </b-col>
            </b-row>
        </b-card>

        <template v-if="price !== null">

            <b-card>
                <b-form-group label="Transport Free Price">
                    <b-input type="number" v-model="price.transport_free"></b-input>
                </b-form-group>
                <b-form-group label="Transport Free Price EU">
                    <b-input v-model="price.transport_free_eu"></b-input>
                </b-form-group>
                <b-form-group label="DPD AT Price">
                    <b-input v-model="price.dpd_at"></b-input>
                </b-form-group>
                <b-form-group label="DPD EU Price">
                    <b-input v-model="price.dpd_eu"></b-input>
                </b-form-group>
                <b-form-group label="Lifferservice Price">
                    <b-input v-model="price.lifferservice"></b-input>
                </b-form-group>
                <b-form-group label="Lifferservice Limit Price">
                    <b-input v-model="price.limit_lifferservice"></b-input>
                </b-form-group>
                <b-form-group label="Gift Limit Price">
                    <b-input v-model="price.limit_gift"></b-input>
                </b-form-group>
            </b-card>

            <b-card title="Kombinierter Versand">
                <b-form-group label="DPD AT Price">
                    <b-input v-model="price.dpd_at_mix"></b-input>
                </b-form-group>
                <b-form-group label="DPD EU Price">
                    <b-input v-model="price.dpd_eu_mix"></b-input>
                </b-form-group>
                <b-form-group label="Lifferservice Price">
                    <b-input v-model="price.lifferservice_mix"></b-input>
                </b-form-group>
            </b-card>
        </template>

    </div>
</template>

<script>
    import Navbar from "../../Partials/Navbar";
    import Http from '../../../Services/HttpService/HttpService'
    import Notificaion from '../../../Services/Notification/Nottification'

    export default {
        name: "Index",
        components: {Navbar},
        data() {
            return {
                price: null,
                showLifferservice: false,
                showDpdExpress: false,
                showDpdEU: false,
                showDpdInPerson: false,
                showPaymentPurhcaseInvoice: false,
                showPaymentVisa: false,
                showPaymentEps: false,
                showPaymentGiropay: false,
            }
        },
        methods: {
            storePrices() {
                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'setting/price/update', {
                    values: {
                        PRICE_TRANSPORT_FREE: this.price.transport_free,
                        PRICE_TRANSPORT_FREE_EU: this.price.transport_free_eu,
                        PRICE_TRASPORT_DPDAT: this.price.dpd_at,
                        PRICE_TRASPORT_DPDAT_MIX: this.price.dpd_at_mix,
                        PRICE_TRASPORT_DPD_EU: this.price.dpd_eu,
                        PRICE_TRASPORT_DPD_EU_MIX: this.price.dpd_eu_mix,
                        PRICE_TRASPORT_DPD_EXPRESS: this.price.dpd_at_express,
                        PRICE_TRASPORT_DPD_EXPRESS_LIEFERSERVICE: this.price.lifferservice,
                        PRICE_TRASPORT_DPD_EXPRESS_LIEFERSERVICE_MIX: this.price.lifferservice_mix,
                        PRICE_LIMIT_LIFFERSERVICE: this.price.limit_lifferservice,
                        PRICE_LIMIT_FREE_GIFT: this.price.limit_gift,
                    },
                    display: {
                        show_lifferservice: this.showLifferservice,
                        show_dpd_express: this.showDpdExpress,
                        show_eu: this.showDpdEU,
                        show_inperson: this.showDpdInPerson,
                        show_purchase_invoice: this.showPaymentPurhcaseInvoice,
                        show_payment_visa: this.showPaymentVisa,
                        show_payment_eps: this.showPaymentEps,
                        show_payment_giropay: this.showPaymentGiropay,
                    }
                })
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            Notificaion.success(response.data.message)
                        } else {
                            Notificaion.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            getPrices() {
                this.$Progress.start();
                Http.get(Http.apiurlV2() + 'setting/price/index')
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.price = response.data.data;
                            this.showDpdExpress = response.data.data.show_dpd;
                            this.showDpdEU = response.data.data.show_eu;
                            this.showDpdInPerson = response.data.data.show_inperson;
                            this.showLifferservice = response.data.data.show_lifferservice;
                            this.showPaymentPurhcaseInvoice = response.data.data.show_purchase_invoice;
                            this.showPaymentVisa = response.data.data.show_payment_visa;
                            this.showPaymentEps = response.data.data.show_payment_eps;
                            this.showPaymentGiropay = response.data.data.show_payment_giropay;

                        } else {
                            Notificaion.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
        },
        created() {
            this.getPrices();
        }
    }
</script>

<style scoped>

</style>